export default "__VITE_ASSET__qTHsxUdK__"